import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';
import Icon_Add from '../../Assets/Icons/Icon_Add.png'
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png'
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Toggle from '../ERUMAUI/UI_Toggle';



export default function UI_Panel_Center() {
    const { Account, Loading } = useAuth();
    // const [Template_List, Template_List_Set] = useState([]);
    const [Edited_Row, Edited_Row_Set] = useState({ Type: null, Type_2: null, Index: null });
    const [Edit_Buffer, Edit_Buffer_Set] = useState("");
    const [Change_InProgress, Change_InProgress_Set] = useState(false);
    const { Template_Editor_Unsaved, Template_Editor_Unsaved_Set, Templates_Edit_Save_Attempt, Templates_Load, Template_List, Template_List_Set, Templates_Edit_Save, Templates_Add, Templates_Edit, Templates_Delete, Templates_RoomType_Add, Templates_RoomType_Edit, Templates_RoomType_ToggleHasHours, Templates_RoomType_EditHours, Templates_RoomType_ToggleHasAircon } = useTemplating();
    const { Time_Parse } = useScheduleManagement();
    const UI = useContext(Context_UI);

    useEffect(() => {
        // console.log(Template_List);
        // Handle_Update();
    }, []);

    const Handle_Update = async () => {
        try {
            // console.log(Template_List);
            Change_InProgress_Set(true);
            // Template_List_Set([Template]);
            await Templates_Edit_Save_Attempt();
            Change_InProgress_Set(false);
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "List updated!", "It worked.");
        } catch (Error) {
            console.error("Error: " + Error);
        }

    }




    const Handle_RowClick = (Type, Type_2, Index, Value) => {
        Edited_Row_Set({ Type, Type_2, Index });
        Edit_Buffer_Set(Value);
    }

    const Handle_Input_Change = (e) => {
        Edit_Buffer_Set(e.target.value);
    }

    const Handle_Input_Blur = (Path) => {
        if (Edited_Row.Type && Edited_Row.Index !== null) {
            Templates_Edit(Path, Edited_Row.Type, Edited_Row.Index, Edit_Buffer);
        }
        Edited_Row_Set({ Type: null, Type_2: null, Index: null });
    };

    const Handle_Add = (Path, _, Index) => {
        if (!Template_Editor_Unsaved) Template_Editor_Unsaved_Set(true);
        const Index_New = Templates_Add(Path);
        Edit_Buffer_Set("");
        Edited_Row_Set({ Type: Path, Type_2: null, Index: Index_New });

    };

    const Handle_Delete = (Path, Index) => {
        Templates_Delete(Path, Index);
        Edit_Buffer_Set("");
        Edited_Row_Set({ Type: null, Type_2: null, Index: null });
    };


    const Handle_KeyDown = (event) => {
        if (event.key === 'Enter') {
            // Edit_Buffer_Set(Template_List[Edited_Row.Type][Edited_Row.Type_2][Edited_Row.Index + 1]);
            // Edited_Row_Set(prev => ({
            //     ...prev,
            //     Index: prev.Index + 1
            // }));
            if (Edited_Row.Type_2 !== null) {
                // Handle_RowClick(Edited_Row.Type, Edited_Row.Type_2, Edited_Row.Index + 1, Template_List[Edited_Row.Type][Edited_Row.Type_2][Edited_Row.Index + 1]);
                // Edit_Buffer_Set(Value);
            } else {
                // Handle_RowClick(Edited_Row.Type, Edited_Row.Type_2, Edited_Row.Index + 1, Template_List[Edited_Row.Type][Edited_Row.Index + 1]);
            }

        }
    }

    const Path_Get = (Data, Path) => {
        return Path.split('.').reduce((acc, key) => acc && acc[key], Data);
    }

    const Path_Set = (Data, Path, Value) => {
        const Keys = Path.split('.');
        const Key_Last = Keys.pop();
        const Target = Keys.reduce((acc, key) => acc[key], Data);
        Target[Key_Last] = Value;
    }

    const Path_Delete = (Data, Path, Index) => {
        const List = Path_Get(Data, Path);
        if (Array.isArray(List)) {
            List.splice(Index, 1);
        }
    }

    const Table = ({ Path, Title }) => {
        const List = Path_Get(Template_List, Path) || [];

        return (
            <>
                {List.length > 0 ? (
                    <>
                        <UI_Divider Text={Title} />
                        <table className='TP_Table'>
                            <thead>
                                <tr className='TP_Table_Row' Type="Primary">
                                    <td className='TP_Table_Cell'>
                                        <p className='TP_Table_Cell_Data'>
                                            Item description
                                        </p>
                                    </td>
                                    <td className='TP_Table_Cell'>
                                        <p className='TP_Table_Cell_Data'>
                                            Controls
                                        </p>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {List.map((Item, Index) => (
                                    <tr className='TP_Table_Row' key={`${Path}.${Index}`}>
                                        <td
                                            className='TP_Table_Cell'
                                            onClick={() => Handle_RowClick(Path, null, Index, Item)}
                                        >
                                            {Edited_Row.Type === Path && Edited_Row.Type_2 === null && Edited_Row.Index === Index ? (
                                                <UI_Input_Text
                                                    Input_Type="text"
                                                    Value={Edit_Buffer}
                                                    onChange={Handle_Input_Change}
                                                    onBlur={() => Handle_Input_Blur(Path)}
                                                    autoFocus
                                                    Value_Set_Enable={true}
                                                    Classes="TP_Table_Cell_Data"
                                                />
                                            ) : (
                                                <p className='TP_Table_Cell_Data'>
                                                    {typeof Item === "object" ? Item.Name || JSON.stringify(Item) : Item}
                                                </p>
                                            )}
                                        </td>
                                        <td className='TP_Table_Cell'>
                                            <UI_Button
                                                Icon={Icon_Delete}
                                                Icon_Position="Center"
                                                Type="Icon"
                                                Fill={true}
                                                OnClick={() => Handle_Delete(Path, Index)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>

                ) : (
                    <p className='General_Paragraph'>List is currently empty.</p>
                )}

                <UI_Button
                    Text="Add new item"
                    Icon={Icon_Add}
                    Icon_Position="Left"
                    OnClick={() =>
                        Handle_Add(Path, null, List.length)
                    }
                />
            </>
        );
    };

    const Handle_RoomType_RowClick = (Type, Type_2, Index, Value) => {
        Edited_Row_Set({ Type: "RoomType", Type_2: null, Index });
        Edit_Buffer_Set(Value);
    }

    const Handle_RoomType_Add = () => {
        const Index_New = Templates_RoomType_Add();

        Edit_Buffer_Set("");
        Edited_Row_Set({ Type: "RoomType", Type_2: null, Index: Index_New });
    }

    useEffect(() => {
        const Handle_Toggle = ({ ID, State }) => {
            const Index = ID.split("_")[1];
            if (ID.split("_")[0] === "RoomType") {
                Handle_RoomType_ToggleHasHours(Index, State);
            }
            if (ID.split("_")[0] === "RoomTypeAircon") {
                Handle_RoomType_ToggleHasAircon(Index, State);
            }
        }
        UI.on("Button_Toggled", Handle_Toggle);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle)
        };
    });

    const Handle_RoomType_Input_Blur = () => {
        // console.log(Edited_Row.Index);
        if (Edited_Row.Type && Edited_Row.Index !== null) {
            Templates_RoomType_Edit("RoomType", Edited_Row.Index, Edit_Buffer);
        }
        Edited_Row_Set({ Type: null, Type_2: null, Index: null });
    };

    const Handle_RoomType_ToggleHasHours = (Index, State) => {
        Templates_RoomType_ToggleHasHours(Index, State);
        /*const Templates_Updated = [...Template_List];
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Templates_Updated[0].RoomType[Index].hasDefinedHours = State_New;
        Template_List_Set(Templates_Updated);
        Template_Editor_Unsaved_Set(true);*/
    };

    const Handle_RoomType_ToggleHasAircon = (Index, State) => {
        Templates_RoomType_ToggleHasAircon(Index, State);
    }





    if (Loading) {
        return null;
    }
    return (

        <div style={{margin: "20px"}}>
            {Template_List.length !== 0 ?
                <UI_Horizontal_Tabs
                    id="TemplateScreen"
                    Selectors={[
                        {
                            Icon: <UI_Icon Name="User_Edit" />,
                            Text: "Accounts Management"
                        },
                        {
                            Icon: <UI_Icon Name="User_Edit" />,
                            Text: "Map Editor"
                        },
                        {
                            Icon: <UI_Icon Name="User_Edit" />,
                            Text: "Schedules Management"
                        }
                    ]}
                    UIDs={[
                        "Accounts",
                        "MapEditor",
                        "SchedulesManagement"
                    ]}
                    Selected="Tab_Accounts"
                    Components={[
                        <>
                            <h1 className='General_Title'>
                                Accounts Management
                            </h1>
                            <Table Title="Reasons for denial of registration request" Path="Reason.Account_Denied" />
                        </>,
                        <>
                            <h1 className='General_Title'>
                                Map Editor
                            </h1>
                            {Template_List?.RoomType?.length > 0 ? (
                                <>
                                    <UI_Divider Text="Room types" />
                                    <table className='TP_Table TP_Table_RoomType'>
                                        <thead>
                                            <tr className='TP_Table_Row' Type="Primary">
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        Room
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        Has airconditioner?
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        Has blocked hours?
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        Controls
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        SUN
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        MON
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        TUE
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        WED
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        THU
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        FRI
                                                    </p>
                                                </td>
                                                <td className='TP_Table_Cell'>
                                                    <p className='TP_Table_Cell_Data'>
                                                        SAT
                                                    </p>
                                                </td>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Template_List.RoomType.map((Item, Index) => (
                                                <tr className='TP_Table_Row' key={`.${Index}`}>
                                                    <td
                                                        className='TP_Table_Cell'
                                                        onClick={() => Handle_RoomType_RowClick("RoomType", null, Index, Item.Name)}
                                                    >
                                                        {Edited_Row.Type === "RoomType" && Edited_Row.Type_2 === null && Edited_Row.Index === Index ? (

                                                            <UI_Input_Text
                                                                Input_Type="text"
                                                                Value={Edit_Buffer}
                                                                onChange={Handle_Input_Change}
                                                                onBlur={Handle_RoomType_Input_Blur}
                                                                autoFocus
                                                                Value_Set_Enable={true}
                                                                Classes="TP_Table_Cell_Data"
                                                            />
                                                        ) : (
                                                            <p className='TP_Table_Cell_Data'>
                                                                {Item.Name}
                                                            </p>
                                                        )}
                                                    </td>
                                                    <td className='TP_Table_Cell'>
                                                        <UI_Toggle
                                                            Text="Has airconditioner"
                                                            id={`RoomTypeAircon_${Index}`}
                                                            Type="Switch"
                                                            Selected={Item.hasAirconditioner ? "true" : "false"}
                                                        />
                                                    </td>
                                                    <td className='TP_Table_Cell'>
                                                        <UI_Toggle
                                                            Text="Has blocked hours"
                                                            id={`RoomType_${Index}`}
                                                            Type="Switch"
                                                            Selected={Item.hasDefinedHours ? "true" : "false"}
                                                        />
                                                    </td>
                                                    <td className='TP_Table_Cell'>
                                                        <UI_Button
                                                            Icon={Icon_Delete}
                                                            Icon_Position="Center"
                                                            Type="Icon"
                                                            Fill={true}
                                                            OnClick={() => Handle_Delete("RoomType", Index)}
                                                        />
                                                    </td>
                                                    {Item?.DefinedHours.map((Hours) => (
                                                        <td className='TP_Table_Cell' onClick={Item.hasDefinedHours ? () => Templates_RoomType_EditHours(Index) : null}>
                                                            {Item.hasDefinedHours ?
                                                                <>
                                                                    {Hours.hasDefinedHours ?
                                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                                            <p className='General_Paragraph'>
                                                                                {Time_Parse(Hours.Start, "Time")}
                                                                            </p>
                                                                            <p className='General_Paragraph'>
                                                                                {Time_Parse(Hours.End, "Time")}
                                                                            </p>
                                                                        </div>
                                                                        :
                                                                        <p className='General_Paragraph'>
                                                                            Free
                                                                        </p>
                                                                    }
                                                                </>

                                                                :
                                                                <p className='General_Paragraph'>
                                                                    -
                                                                </p>
                                                            }

                                                        </td>
                                                    ))}

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>

                            ) : (
                                <p className='General_Paragraph'>List is currently empty.</p>
                            )}

                            <UI_Button
                                Text="Add new item"
                                Icon={Icon_Add}
                                Icon_Position="Left"
                                OnClick={() =>
                                    Handle_RoomType_Add()
                                }
                            />
                        </>,
                        <>
                            <h1 className='General_Title'>
                                Schedules Management
                            </h1>
                            <Table Title="Available equipment" Path="Equipment" />
                            <Table Title="Type of activities" Path="Activity.Type" />
                            <Table Title="Activity subjects" Path="Activity.Subject" />
                            <Table Title="Requester types" Path="RequesterType" />
                            <Table Title="Reasons for rejection of reservation" Path="Reason.Request_Denied" />
                            <Table Title="Reasons for rescheduling of reservation" Path="Reason.Request_Rescheduled" />
                            <Table Title="Reasons for relocation of reservation" Path="Reason.Request_Relocated" />
                            <Table Title="Reasons for editing of reservation" Path="Reason.Request_Edited" />
                            <Table Title="Delegated staffs" Path="DelegatedStaff" />
                        </>
                    ]}
                />

                :
                ""
            }

        </div>
    );
}
